<template>
  <div v-if="data.VideoURL && data.VideoURL.length > 0">
    <div class="video-responsive" 
      v-if="data.TypeVideo === 'youtube'"
    >
      <iframe
        width="100%"
        :src="`https://www.youtube.com/embed/${url}?controls=0`"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </div>
    <div
      v-else-if="data.TypeVideo === 'vimeo'"
    >
      <div
        style="padding:56.25% 0 0 0;position:relative;"
      >
        <iframe
          :src="`https://player.vimeo.com/video/${url}?autoplay=1&title=0&byline=0&portrait=0`"
          style="position:absolute;top:0;left:0;width:100%;height:100%;"
          frameborder="0"
          allow="fullscreen"
          allowfullscreen>
        </iframe>
      </div>
      <!-- <script src="https://player.vimeo.com/api/player.js"></script> -->
    </div>
    <video controls
      v-else-if="data.TypeVideo === 'file'"
      width="100%"
    >
      <source :src="url" type="video/mp4">
      <!-- <source src="movie.ogg" type="video/ogg"> -->
      Your browser does not support the video tag.
    </video>
    <!-- <video
      v-else-if="data.TypeVideo === 'file'"
      controls=""
      preload="none"
      width="100%"
      :src="url"
    >
      <source _ngcontent-c8="" class="ng-tns-c8-3" type="video/mp4; codecs=&quot;avc1.42E01E, mp4a.40.2&quot;"
        :src="url"
      >
      <source _ngcontent-c8="" class="ng-tns-c8-3" type="video/ogg; codecs=&quot;theora, vorbis&quot;"
        :src="url"
        >
      <source _ngcontent-c8="" class="ng-tns-c8-3" type="video/webm; codecs=&quot;vp8, vorbis&quot;" 
        :src="url"
      >
      Video tag not supported. Download the video <a _ngcontent-c8="" class="ng-tns-c8-3" :href="url">here</a>
    </video> -->
    <div v-else> </div>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
      url: null
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
    },
    watch: {
      'data.VideoURL': {
        handler: function (newValue) {
          this.url = this.prepareURL(newValue)
        },
        deep: true
      }
    },
    mounted() {
      this.url = this.prepareURL(this.data.VideoURL)
    },
    methods: {
      prepareURL (url) {
        if (this.data.TypeVideo === 'youtube') {
          // https://www.youtube.com/watch?v=x86doi7auJA
          if (url && url.length > 0) {
            const aux = url.split('?v=')
            return aux[aux.length-1]
          }
        } else if (this.data.TypeVideo === 'vimeo') {
          // https://player.vimeo.com/video/351995036?autoplay=false&title=0&byline=0&portrait=0
          if (url && url.length > 0) {
            let aux = url.split('/')
            aux = aux[aux.length-1]
            return aux.split('?')[0]
          }
        } else {
          return url
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .video-responsive {
    position: relative;
    padding-bottom: 56.25%; /* 16/9 ratio */
    padding-top: 30px; /* IE6 workaround*/
    height: 0;
    overflow: hidden;
  }

  .video-responsive iframe,
  .video-responsive object,
  .video-responsive embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
